import { memoryRepository } from '../repositories/memory-repository';

async function getMemory(chapter) {
    return memoryRepository.getMemory(chapter);
}

export {
    getMemory
};
